import { create } from 'zustand'

interface PusherConnectionState {
  reconnectCount: number
  markReconnected: () => void
}

export const usePusherConnectionStore = create<PusherConnectionState>((set) => ({
  reconnectCount: 0,
  markReconnected: () => set((state) => ({ reconnectCount: state.reconnectCount + 1 })),
}))
